module.exports = __webpack_public_path__ + "static/profilepic_matt-8de6ba8618d424e9977e96a16ee1ec73.jpeg";